import { render, staticRenderFns } from "./evolutionPivotFirm.vue?vue&type=template&id=9f875cfa&scoped=true"
import script from "./evolutionPivotFirm.vue?vue&type=script&lang=js"
export * from "./evolutionPivotFirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f875cfa",
  null
  
)

export default component.exports